<template>
    <!-- NOTE: Expanded summary is temperarily disabled - Marc Marsocci 7-27-2017 -->
    <div @click='openSummaries'>
        <div class='summary' :class="{'col-md-12': !mobile_manager.grid_view, 'col-md-3 grid-margin': mobile_manager.grid_view}">
            <div class='row mobile-view'>
                <!-- Images -->
                <div class='min-width' :class="{'col-md-4': !mobile_manager.grid_view}" >
                    <!-- Viewable images -->
                    <div>
                        <thumbnail-viewer :object='object' width='193' height='158'></thumbnail-viewer>
                    </div>
                </div>
                <div class='col-md-8' v-if='!mobile_manager.grid_view'>

                    <!-- Summary -->
                    <div>
                        <!-- Title -->
                        <div class='row'>
                            <div class='col-md-10'>
                                <router-link @click.native.stop :to="{name: 'object', params: {id: object._id}}">
                                    <h4 class='summary-title truncate' :title='object.searchable.title[0]'>{{object.searchable.title[0]}}</h4>
                                </router-link>
                            </div>
                            <div class='col-md-2 hidden-sm hidden-xs'>
                                <!-- Expand buttons -->
                                <!-- <div v-if='object._index != "association"' class='expand-margin fake-link pull-right'>
                                    <img v-show='!object.open_summary' src='/images/facet_toggle_arrow.svg' class='rotate90'>
                                    <img v-show='object.open_summary' src='/images/facet_toggle_arrow.svg'>
                                </div> -->
                            </div>
                        </div>

                        <!-- The Rest of the details -->
                        <!-- Archives Collection-->
                        <div v-if='object._index == "archival_collection"'>
                            <archival-collection-summary :object='object'></archival-collection-summary>
                            <!-- <transition name='slide'>
                                <collection-extended class='hidden-xs hidden-sm' v-show='object.open_summary' :object='object'></collection-extended>
                            </transition> -->
                        </div>

                        <!-- Archives Series-->
                        <div v-if='object._index == "archival_series"'>
                            <archival-series-summary :object='object'></archival-series-summary>
                            <!-- <transition name='slide'>
                                <series-extended class='hidden-xs hidden-sm' v-show='object.open_summary' :object='object'></series-extended>
                            </transition> -->
                        </div>

                        <!-- Archives File Unit -->
                        <div v-else-if='object._index == "archival_fileunit"'>
                            <archival-fileunit-summary :object='object'></archival-fileunit-summary>
                            <!-- <transition name='slide'>
                                <file-unit-extended class='hidden-xs hidden-sm' v-show='object.open_summary' :object='object'></file-unit-extended>
                            </transition> -->
                        </div>

                        <!-- Archives Item -->
                        <div v-else-if='object._index == "archival_item"'>
                            <archival-item-summary :object='object'></archival-item-summary>
                            <!-- <transition name='slide'>
                                <item-extended class='hidden-xs hidden-sm' v-show='object.open_summary' :object='object'></item-extended>
                            </transition> -->
                        </div>

                        <!-- Collection Objects -->
                        <div v-else-if='object._index == "mariners_collection" || object._index == "monitor_collection"'>
                            <collection-summary :object='object'></collection-summary>
                            <!-- <transition name='slide'>
                                <object-extended class='hidden-xs hidden-sm' v-show='object.open_summary' :object='object'></object-extended>
                            </transition> -->
                        </div>

                        <!-- Library Objects -->
                        <div v-else-if='object._index == "library"'>
                            <library-summary :object='object'></library-summary>
                            <!-- <transition name='slide'>
                                <library-extended class='hidden-xs hidden-sm' v-show='object.open_summary' :object='object'></library-extended>
                            </transition> -->
                        </div>

                        <!-- Exhibits -->
                        <div v-else-if='object._index == "exhibit"'>
                            <exhibit-summary :object='object'></exhibit-summary>
                            <!-- <transition name='slide'>
                                <exhibit-extended class='hidden-xs hidden-sm' v-show='object.open_summary' :object='object'></exhibit-extended>
                            </transition> -->
                        </div>

                        <!-- Associations -->
                        <div v-else-if='object._index == "association"'>
                            <association-summary :object='object'></association-summary>
                            <!-- No Extended-->
                        </div>

                        <!-- Vessel -->
                        <div v-else-if='object._index == "vessel"'>
                            <vessel-summary :object='object'></vessel-summary>
                            <!-- <transition name='slide'>
                                <vessel-extended class='hidden-xs hidden-sm' v-show='object.open_summary' :object='object'></vessel-extended>
                            </transition> -->
                        </div>
                    </div>
                </div>
            </div>
            <hr v-show='!mobile_manager.grid_view'>
        </div>
    </div>
</template>

<script>
    import EventHub from '../eventHub.js'
    import ThumbnailViewerVue from './../thumbnailViewer.vue'
    import CollectionSummaryVue from './collectionSummary.vue'
    import ArchivalCollectionSummaryVue from './archivalCollectionSummary.vue'
    import ArchivalSeriesSummaryVue from './archivalSeriesSummary.vue'
    import ArchivalFileunitSummaryVue from './archivalFileunitSummary.vue'
    import ArchivalItemSummaryVue from './archivalItemSummary.vue'
    import LibrarySummaryVue from './librarySummary.vue'
    import ExhibitSummaryVue from './exhibitSummary.vue'
    import AssociationSummaryVue from './associationSummary.vue'
    import VesselSummaryVue from './vesselSummary.vue'

    import CollectionExtendedVue from './extended_summaries/archivalCollection.vue'
    import SeriesExtendedVue from './extended_summaries/archivalSeries.vue'
    import FileUnitExtendedVue from './extended_summaries/archivalFileUnit.vue'
    import ItemExtendedVue from './extended_summaries/archivalItem.vue'
    import ExhibitExtendedVue from './extended_summaries/exhibit.vue'
    import LibraryExtendedVue from './extended_summaries/library.vue'
    import ObjectExtendedVue from './extended_summaries/collection.vue'
    import VesselExtendedVue from './extended_summaries/vessel.vue'
    import MobileManager from '../mobileManager.js'

    export default {
        name: 'record-summary',
        props: ['objWithSource', 'window_width'],
        data: function () {
            return {
                mobile_manager: MobileManager
            }
        },
        methods: {
            openSummaries: function () {
                EventHub.$emit('open-summaries', this.object)
            }
        },
        computed: {
            object: function () {
                var object = this.objWithSource._source
                object._index = this.objWithSource._index
                object._id = this.objWithSource._id
                return object
            }
        },
        components: {
            'thumbnail-viewer': ThumbnailViewerVue,
            'collection-summary': CollectionSummaryVue,
            'archival-collection-summary': ArchivalCollectionSummaryVue,
            'archival-series-summary': ArchivalSeriesSummaryVue,
            'archival-fileunit-summary': ArchivalFileunitSummaryVue,
            'archival-item-summary': ArchivalItemSummaryVue,
            'library-summary': LibrarySummaryVue,
            'exhibit-summary': ExhibitSummaryVue,
            'association-summary': AssociationSummaryVue,
            'vessel-summary': VesselSummaryVue,

            'object-extended': ObjectExtendedVue,
            'collection-extended': CollectionExtendedVue,
            'series-extended': SeriesExtendedVue,
            'file-unit-extended': FileUnitExtendedVue,
            'item-extended': ItemExtendedVue,
            'library-extended': LibraryExtendedVue,
            'exhibit-extended': ExhibitExtendedVue,
            'vessel-extended': VesselExtendedVue
        }
    };
</script>

<style lang="scss">
    .summary {
        margin-bottom: 5px;

        // apply if greater than 992px (bootstrap large)
        @media (max-width: 991px) {
            padding-left: 0;
            padding-right: 0;
        }

        .nonviewable-image {
            text-align: center;
        }

        .expand-margin {
            margin-top: 10px;
        }

        .min-width {
            min-width: 135px;
        }

        .grid-margin {
            margin-bottom: 25px;
        }

        button {
            margin-top: 2px;
            margin-right: 2px;
        }

        .row {
            margin-bottom: 5px;
        }
    }
</style>
